import type { HelpFile } from '../../types/help'
import { IdentityManagerPickerTestIds } from '../../../testids/IdentityManagerPickerTestIds'

export const identityManagerPickerHelp: HelpFile = {
  docPage: '/docs/identity/onboarding',
  texts: {
    [IdentityManagerPickerTestIds.identityManagerPicker]: 'Wählen Sie die Vorgesetzten-Identität. Geben Sie mindestens 2 Zeichen ein, um aktive Workforce-Identitäten zu durchsuchen; die Ergebnisliste zeigt den Identitäts-Anzeigenamen mit dem Party-Anzeigenamen als sekundären Hinweis, falls sie sich unterscheiden.',
    [IdentityManagerPickerTestIds.comboboxManagerIdentity]: 'Tippen Sie, um nach einer Identität nach Anzeigename zu suchen (sucht in Identitäts- ODER Party-Anzeigename).',
    [IdentityManagerPickerTestIds.managerInactiveAdvisory]: 'Die ausgewählte Vorgesetzten-Identität ist nicht im Zustand ACTIVE. Das Backend akzeptiert inaktive Vorgesetzte — dieser Hinweis ist nicht blockierend. Bestätigen Sie vor dem Speichern.',
  },
}
